import React from 'react';

import { StyleSheet, View } from 'react-native';
import Text from '../global/Text';
import fontMaker from '../../utils/font';
import { SCREEN_WIDTH } from '../../utils/screensize';

import { appversion } from '../../constants/appversion';

const IS_LARGE_DESKTOP = SCREEN_WIDTH >= 1280;

const LandingVersion = () => {
  return (
    <View style={styles.version}>
      <Text style={styles.versionText}>v{appversion}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  version: {
    position: 'absolute',
    bottom: 12,
    left: IS_LARGE_DESKTOP ? 70 : 62
  },
  versionText: {
    ...fontMaker({ weight: 'Regular' }),
    color: 'rgba(255,255,255,0.6)',
    fontWeight: 600,
    fontSize: 14
  }
});

export default LandingVersion;
